import React, { useContext, useState } from "react";
import ReportContext from "../../context/report";
import { CircularProgress, Stack } from '@mui/material';
import { useParams } from "react-router-dom";
import { useGetPublishLinkMutation } from "../../features/report/reportApiSlice";

const SharedReport = () => {
    const report = useContext(ReportContext);
    const [iframeLoading, setIframeLoading] = useState(true);
    const [currentIframeLink, setCurrentIframeLink] = useState(null);
    const { id } = useParams();
    const [getPublishLink] = useGetPublishLinkMutation();

    React.useEffect(() => {
        if (!id) return;

        let isMounted = true;
        setIframeLoading(true);

        (async () => {
            try {
                const result = await getPublishLink(id).unwrap();
                if (isMounted) {
                    report.setShareReports(result?.data);
                    setCurrentIframeLink(`${result?.data?.publish_link}&embed=true`);
                }
            } catch (error) {
                console.log(error, "error");
            }
        })();

        return () => {
            isMounted = false;
        };
    }, [id]);

    React.useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const shareToken = urlParams.get("shareToken");
        // console.log(shareToken, ">> hare ytoken ")
        if (shareToken) {
            window.__SHARE_TOKEN__ = shareToken; // global store
        }
    }, []);

    return (
        <div style={{ width: "100%", height: "calc(100vh - 65px)", }}>
            {(iframeLoading) && (
                <Stack sx={{ color: 'grey.500', height: "100%", alignItems: 'center', justifyContent: 'center' }} spacing={2} direction="row">
                    <CircularProgress color="inherit" disableShrink />
                </Stack>
            )}
            {currentIframeLink ? (
                <iframe
                    // src={iframeLink}
                    src={currentIframeLink}
                    title="Shared Report"
                    width="100%"
                    height="100%"
                    style={{ border: "none" }}
                    onLoad={() => setIframeLoading(false)}
                />
            ) : (
                !iframeLoading && <p>No report to display</p>
            )}

        </div>
    )
}
export default SharedReport;